import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CompanyAppliedFilter, FilterItem, SearchOptions } from 'src/storage/contact-search/search.state';
import { MatDialog } from '@angular/material/dialog';
import { SaveSearchComponent } from '../dialog/save-search/save-search.component';
import { FilterDto } from 'src/portal/search-api/models/filter-dto';
import { GlobalSearchResultTypeEnum } from 'src/portal/search-api/models/global-search-result-type-enum';


@Component({
  selector: 'advanced-company-filter',
  templateUrl: './advanced-company-filter.component.html',
  styleUrls: ['./advanced-company-filter.component.scss']
})

export class AdvancedCompanyFilterComponent implements OnChanges,OnInit {


  filterValue:any = [];

  locationFilter : FilterDto;

  @Input() searchState:any;
  @Output() filterChanged = new EventEmitter<CompanyAppliedFilter>();
  @Output() saveSearch = new EventEmitter();
  innerSearchOptions: SearchOptions = {
    showInactiveCompanies: false,
    hideMyOwnedCompanies: false,
    showOnlyDirectDials: false,
  };
  searchOptions: SearchOptions;
  websites:any;
  constructor(public dialog: MatDialog) {
    console.log(this.searchState)
  }

  ngOnChanges() {

  }
  ngOnInit(){
    this.websites = this.searchState.companySearch?.filters?.website?.items.filter(x=>x.checked == true);

  }
  public filter(filters: CompanyAppliedFilter) {
     console.log(filters)
    let objIndex = this.filterValue.findIndex((obj => obj.filterName == filters.filterName));
    if(objIndex != -1){
      this.filterValue[objIndex] = filters
    }
    else
      this.filterValue = [{...filters},...this.filterValue]
  }

  public urlDomain(data :FilterItem[]) {

    let domains:FilterItem[] = [];
    data.forEach(element => {
      const matches = element.caption.match(/^(?:https?:)?(?:\/\/)?([^\/\?]+)/i);
      const hostname = matches && matches[1];
      element.caption = hostname;
      domains.push(element);
    });
    this.filter({ website: domains, filterName: 'website' })
  }

  filterLocation(event){

    let { code, codeIn, codeNotIn } = event.location

    this.locationFilter = {
      areaCodeIn : code == 'area' && codeIn.length ? codeIn.split(',') : [],
      areaCodeNotIn: code == 'area' && codeNotIn.length ? codeNotIn.split(',') : [],
      postalCode : code == 'zip' && codeIn.length ? codeIn.split(',') : [],
      zipCodeNotIn : code == 'zip' && codeNotIn.length ? codeNotIn.split(',') : [],
      filterType: GlobalSearchResultTypeEnum.COMPANY
    }
  }
  public setSearchOptions(searchOptions: SearchOptions) {

    this.searchOptions = searchOptions
  }
  onSearch(){
    localStorage.setItem("activetabindex","1");
    console.log(...this.filterValue)
    this.filterChanged.emit({...this.filterValue,...this.searchOptions,...this.locationFilter});
  }
  openDialog() {
    const dialogRef = this.dialog.open(SaveSearchComponent, {width: '500px'});

    dialogRef.afterClosed().subscribe(name => {
      if(name){

        this.saveSearch.emit({...this.filterValue,...this.searchOptions,...this.locationFilter, name});
        //this.filterChanged.emit({...this.filterValue,...this.searchOptions,...this.locationFilter});
      }
    });
  }
}
